import { render, staticRenderFns } from "./StartAssignmentRoot.vue?vue&type=template&id=3be628ca&scoped=true"
import script from "./StartAssignmentRoot.vue?vue&type=script&lang=js"
export * from "./StartAssignmentRoot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be628ca",
  null
  
)

export default component.exports